module.exports = __webpack_public_path__ + "static/media/28.758bbcee.mp3";